import { expValEquals } from '@confluence/feature-experiments';
import { keys } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';
import { confluenceLocalStorageInstance } from '@confluence/storage-manager/entry-points/storageInstance.ts';

/**
 * Single source of truth for Confluence; matches `MarkdownModeView` from
 * `@atlaskit/editor-plugin-markdown-mode`. Import via `entry-points/markdownViewMode`;
 * `@confluence/markdown-mode-view-toggle/entry-points/markdownViewMode` may re-export
 * the type optionally.
 * When adding a mode, update `isMarkdownViewMode` below.
 */
export type MarkdownViewMode = 'source' | 'wysiwyg' | 'preview';

export const DEFAULT_MARKDOWN_VIEW_MODE: MarkdownViewMode = 'wysiwyg';

const isMarkdownViewMode = (value: unknown): value is MarkdownViewMode =>
	value === 'source' || value === 'wysiwyg' || value === 'preview';

export const readStoredMarkdownViewMode = (): MarkdownViewMode => {
	if (!expValEquals('cc-markdown-mode', 'isEnabled', true)) {
		return DEFAULT_MARKDOWN_VIEW_MODE;
	}
	const stored = confluenceLocalStorageInstance.getItem(keys.MARKDOWN_VIEW_MODE);
	return isMarkdownViewMode(stored) ? stored : DEFAULT_MARKDOWN_VIEW_MODE;
};

export const writeStoredMarkdownViewMode = (mode: MarkdownViewMode): void => {
	if (!expValEquals('cc-markdown-mode', 'isEnabled', true)) {
		return;
	}
	confluenceLocalStorageInstance.setItem(keys.MARKDOWN_VIEW_MODE, mode);
};
